const divElements = document.querySelectorAll('.amv-collapsibleFaq__contain .amv-collapsibleFaq__content h4');

// Get all collapsibles
const questions = document.querySelectorAll('.amv-collapsibleFaq__contain');
const faqContainer = document.querySelector('#collapse-container');

// Get all collapsible question titles

// TODO: raggruppare creazione titoli e creazione degli elementi nello stesso ciclo

var faqTitles = [];

divElements.forEach(element => {
  const formattedTitle = element.dataset.title;
    if (! faqTitles.includes(formattedTitle)) {
      faqTitles.push(formattedTitle);
    }
  });

var titleList = document.createElement('ul');
if(titleList) titleList.classList.add('amv-collapsibleFaq__title-list')


faqTitles.forEach((t,j) => {
  var li = document.createElement('li');
  li.textContent = faqTitles[j];
  li.id = faqTitles[j];
  li.classList.add('amv-collapsibleFaq__title')
  titleList.appendChild(li);
  });

var targetDiv = document.querySelector('.amv-collapsibleFaq__index');
if(targetDiv) targetDiv.appendChild(titleList);


// Append all collapsible questions and show first section
questions.forEach(q => {
  faqContainer.appendChild(q)
});

if(questions[0]) questions[0].classList.add('open');

// Cicliamo sugli elementi della lista dei titoli
// Nascondiamo l'elemento aperto e mostriamo quello cliccato

const faqTitleList = titleList.querySelectorAll('li')
faqTitleList.forEach((title, i) => {
  title.addEventListener('click', el => {
    faqContainer.querySelector('.open').classList.remove('open');
    titleList.querySelector('.selected').classList.remove('selected');
    questions[i].classList.add('open');
    faqTitleList[i].classList.add('selected');
  });
});

if(faqTitleList[0]) faqTitleList[0].classList.add('selected');


function showCollapsibleFaq (collapsible) {
  const visibleFaq = document.querySelector('#collapse-container > .open');
  // controllo se ho clickato sulla sezione già aperta
  if(collapsible != visibleFaq) {
    visibleFaq.classList.remove('open');
    collapsible.classList.add('open');
  }
}